import {Module} from "vuex";
import {ModerationTemplatesState} from "@/store/user_management/template_moderation/types";
import {RootState} from "@/store/types";
import {actions} from "@/store/user_management/template_moderation/actions";
import {getters} from "@/store/user_management/template_moderation/getters";
import {mutations} from "@/store/user_management/template_moderation/mutations";

export const state: ModerationTemplatesState = {
  moderationTemplates: []
}

export const moderationTemplates: Module<ModerationTemplatesState, RootState> = {
  state,
  actions,
  getters,
  mutations
}